import gsap, { Power3 } from 'gsap';

import _Header from '../_app/cuchillo/layout/Header';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics } from '../_app/cuchillo/core/Basics';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';

import Sidemenu from './Sidemenu';
import { BurgerIcon } from '../components/BurgerIcon';

export default class Header extends _Header {
  static options = {
    show: { duration: .3, delay: 0, ease: Power3.easeOut },
    hide: { duration: .3, delay: 0, ease: Power3.easeOut }
  }

  static scrollIndicator = GetBy.id('ScrollIndicator');

  static _burgerIcon = null;

  static setWhite(__white = true) {
    if (__white) {
      this.container.classList.add("--white");
      this.scrollIndicator.classList.add("--white");
    }
    else {
      this.container.classList.remove("--white");
      this.scrollIndicator.classList.remove("--white");
    }
  }

  // Desactiva el header mentre passa l'animació general (es reactiva a l'afterShow de cada pàgina)
  static disablePointer() {
    if (this.container) this.container.style.pointerEvents = 'none';
  }

  static enablePointer() {
    if (this.container) this.container.style.pointerEvents = '';
  }

  static init() {
    super.init();

    const burger = GetBy.id('BurgerMenu');
    if (!burger) return;

    this._burgerIcon = new BurgerIcon(burger);
  }

  static directHide() {
    this.isShow = false;
  }

  static show__effect(cb = () => { }) {
    EventDispatcher.dispatchEvent(_Header.ON_SHOW);

    gsap.to(this.container, {
      opacity: 1,
      duration: this.options.show.duration,
      delay: this.options.show.delay,
      ease: this.options.show.duration.ease,
      onComplete: () => {
        this.isShowing = false;
        if (cb) cb();
      }
    });
  }

  static resize() {
    super.resize();
    this._burgerIcon.resize();
  }
}
